var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgNextCameraIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_41074_33706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 6L6 9L2 12V6Z",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 5C6.5 5 6 5.51167 6 6.14286V11.8571C6 12.4883 6.53726 13 7.2 13H13.8C14.4627 13 15 12.4883 15 11.8571V7.5",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1C12.287 1 12.5417 1.18362 12.6325 1.45585L13.3604 3.63962L15.5442 4.36754C15.8164 4.45829 16 4.71305 16 5C16 5.28695 15.8164 5.54171 15.5442 5.63246L13.3604 6.36038L12.6325 8.54415C12.5417 8.81638 12.287 9 12 9C11.713 9 11.4583 8.81638 11.3675 8.54415L10.6396 6.36038L8.45585 5.63246C8.18362 5.54171 8 5.28695 8 5C8 4.71305 8.18362 4.45829 8.45585 4.36754L10.6396 3.63962L11.3675 1.45585C11.4583 1.18362 11.713 1 12 1ZM12 3.77485L11.7991 4.37749C11.7328 4.57656 11.5766 4.73277 11.3775 4.79912L10.7749 5L11.3775 5.20088C11.5766 5.26723 11.7328 5.42344 11.7991 5.62251L12 6.22515L12.2009 5.62251C12.2672 5.42344 12.4234 5.26723 12.6225 5.20088L13.2251 5L12.6225 4.79912C12.4234 4.73277 12.2672 4.57656 12.2009 4.37749L12 3.77485Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_41074_33706"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextCameraIcon);
export default __webpack_public_path__ + "static/media/next-camera-icon.234244f35b28664884f61823e30f4fd2.svg";
export { ForwardRef as ReactComponent };